import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1e161cc4 = () => interopDefault(import('../../../pages/applicants/index.vue' /* webpackChunkName: "pages/applicants/index" */))
const _5ba933d2 = () => interopDefault(import('../../../pages/calculator.vue' /* webpackChunkName: "pages/calculator" */))
const _2a249265 = () => interopDefault(import('../../../pages/complete-profile.vue' /* webpackChunkName: "pages/complete-profile" */))
const _12af4ce1 = () => interopDefault(import('../../../pages/cookie-declaration.vue' /* webpackChunkName: "pages/cookie-declaration" */))
const _f58b38b0 = () => interopDefault(import('../../../pages/create-profile.vue' /* webpackChunkName: "pages/create-profile" */))
const _c730d828 = () => interopDefault(import('../../../pages/edit-position.vue' /* webpackChunkName: "pages/edit-position" */))
const _da659330 = () => interopDefault(import('../../../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _e2262992 = () => interopDefault(import('../../../pages/favorites.vue' /* webpackChunkName: "pages/favorites" */))
const _845a0ce4 = () => interopDefault(import('../../../pages/forgotpassword.vue' /* webpackChunkName: "pages/forgotpassword" */))
const _c9afaade = () => interopDefault(import('../../../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _1947047a = () => interopDefault(import('../../../pages/hotlist-anfragen.vue' /* webpackChunkName: "pages/hotlist-anfragen" */))
const _314e15c5 = () => interopDefault(import('../../../pages/hotlist-candidates/index.vue' /* webpackChunkName: "pages/hotlist-candidates/index" */))
const _f8a27d52 = () => interopDefault(import('../../../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _1369d034 = () => interopDefault(import('../../../pages/inbox.vue' /* webpackChunkName: "pages/inbox" */))
const _18a791ae = () => interopDefault(import('../../../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _18aebb49 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4a39b65a = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _192b0e13 = () => interopDefault(import('../../../pages/matches.vue' /* webpackChunkName: "pages/matches" */))
const _4b6c2566 = () => interopDefault(import('../../../pages/matching.vue' /* webpackChunkName: "pages/matching" */))
const _c8c7062a = () => interopDefault(import('../../../pages/password.vue' /* webpackChunkName: "pages/password" */))
const _e27a8532 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _4c5ac025 = () => interopDefault(import('../../../pages/profilecompletion.vue' /* webpackChunkName: "pages/profilecompletion" */))
const _14562626 = () => interopDefault(import('../../../pages/referral.vue' /* webpackChunkName: "pages/referral" */))
const _ccad0b1a = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _74a36639 = () => interopDefault(import('../../../pages/setup-profile.vue' /* webpackChunkName: "pages/setup-profile" */))
const _49829ae8 = () => interopDefault(import('../../../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _7de36978 = () => interopDefault(import('../../../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _f43ee13c = () => interopDefault(import('../../../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _50badee2 = () => interopDefault(import('../../../pages/company/dashboard.vue' /* webpackChunkName: "pages/company/dashboard" */))
const _0cf596e6 = () => interopDefault(import('../../../pages/company/getstarted.vue' /* webpackChunkName: "pages/company/getstarted" */))
const _5f672e3d = () => interopDefault(import('../../../pages/company/onboarding.vue' /* webpackChunkName: "pages/company/onboarding" */))
const _8591fb8a = () => interopDefault(import('../../../pages/company/positions/index.vue' /* webpackChunkName: "pages/company/positions/index" */))
const _1e2a123a = () => interopDefault(import('../../../pages/company/profile/index.vue' /* webpackChunkName: "pages/company/profile/index" */))
const _0f04908c = () => interopDefault(import('../../../pages/company/signup.vue' /* webpackChunkName: "pages/company/signup" */))
const _11633cf7 = () => interopDefault(import('../../../pages/hyreadmin/demo.vue' /* webpackChunkName: "pages/hyreadmin/demo" */))
const _2cdb4315 = () => interopDefault(import('../../../pages/hyreadmin/impersonate.vue' /* webpackChunkName: "pages/hyreadmin/impersonate" */))
const _312f7e5c = () => interopDefault(import('../../../pages/hyreadmin/unimpersonate.vue' /* webpackChunkName: "pages/hyreadmin/unimpersonate" */))
const _314d9c66 = () => interopDefault(import('../../../pages/myaccount/dashboard.vue' /* webpackChunkName: "pages/myaccount/dashboard" */))
const _c422a10a = () => interopDefault(import('../../../pages/myaccount/profile.vue' /* webpackChunkName: "pages/myaccount/profile" */))
const _0d23a67e = () => interopDefault(import('../../../pages/myaccount/settings.vue' /* webpackChunkName: "pages/myaccount/settings" */))
const _a9a75336 = () => interopDefault(import('../../../pages/company/profile/setup.vue' /* webpackChunkName: "pages/company/profile/setup" */))
const _12d0ff2c = () => interopDefault(import('../../../pages/hyreadmin/portal/screening/index.vue' /* webpackChunkName: "pages/hyreadmin/portal/screening/index" */))
const _43a992ce = () => interopDefault(import('../../../pages/hyreadmin/portal/talent/index.vue' /* webpackChunkName: "pages/hyreadmin/portal/talent/index" */))
const _4f071832 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _628504ec = () => interopDefault(import('../../../pages/hyreadmin/portal/screening/_screeningId.vue' /* webpackChunkName: "pages/hyreadmin/portal/screening/_screeningId" */))
const _2ad87e64 = () => interopDefault(import('../../../pages/hyreadmin/portal/talent/_guid.vue' /* webpackChunkName: "pages/hyreadmin/portal/talent/_guid" */))
const _87e1b594 = () => interopDefault(import('../../../pages/company/positions/_slug/index.vue' /* webpackChunkName: "pages/company/positions/_slug/index" */))
const _1cb87f56 = () => interopDefault(import('../../../pages/company/positions/_slug/edit.vue' /* webpackChunkName: "pages/company/positions/_slug/edit" */))
const _e166ffa8 = () => interopDefault(import('../../../pages/applicants/_id.vue' /* webpackChunkName: "pages/applicants/_id" */))
const _404bc39c = () => interopDefault(import('../../../pages/hotlist-candidates/_candidateId.vue' /* webpackChunkName: "pages/hotlist-candidates/_candidateId" */))
const _7800205e = () => interopDefault(import('../../../pages/jobs/_id.vue' /* webpackChunkName: "pages/jobs/_id" */))
const _28144a72 = () => interopDefault(import('../../../pages/plan/_plan.vue' /* webpackChunkName: "pages/plan/_plan" */))
const _4578645d = () => interopDefault(import('../../../pages/refer/_code.vue' /* webpackChunkName: "pages/refer/_code" */))
const _65233f32 = () => interopDefault(import('../../../pages/talent/_id.vue' /* webpackChunkName: "pages/talent/_id" */))
const _24ab7418 = () => interopDefault(import('../../../pages/hotlist-candidates/_positionSlug/_candidateId.vue' /* webpackChunkName: "pages/hotlist-candidates/_positionSlug/_candidateId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/applicants",
    component: _1e161cc4,
    name: "applicants"
  }, {
    path: "/calculator",
    component: _5ba933d2,
    name: "calculator"
  }, {
    path: "/complete-profile",
    component: _2a249265,
    name: "complete-profile"
  }, {
    path: "/cookie-declaration",
    component: _12af4ce1,
    name: "cookie-declaration"
  }, {
    path: "/create-profile",
    component: _f58b38b0,
    name: "create-profile"
  }, {
    path: "/edit-position",
    component: _c730d828,
    name: "edit-position"
  }, {
    path: "/error",
    component: _da659330,
    name: "error"
  }, {
    path: "/favorites",
    component: _e2262992,
    name: "favorites"
  }, {
    path: "/forgotpassword",
    component: _845a0ce4,
    name: "forgotpassword"
  }, {
    path: "/help",
    component: _c9afaade,
    name: "help"
  }, {
    path: "/hotlist-anfragen",
    component: _1947047a,
    name: "hotlist-anfragen"
  }, {
    path: "/hotlist-candidates",
    component: _314e15c5,
    name: "hotlist-candidates"
  }, {
    path: "/impressum",
    component: _f8a27d52,
    name: "impressum"
  }, {
    path: "/inbox",
    component: _1369d034,
    name: "inbox"
  }, {
    path: "/jobs",
    component: _18a791ae,
    name: "jobs"
  }, {
    path: "/login",
    component: _18aebb49,
    name: "login"
  }, {
    path: "/logout",
    component: _4a39b65a,
    name: "logout"
  }, {
    path: "/matches",
    component: _192b0e13,
    name: "matches"
  }, {
    path: "/matching",
    component: _4b6c2566,
    name: "matching"
  }, {
    path: "/password",
    component: _c8c7062a,
    name: "password"
  }, {
    path: "/privacy-policy",
    component: _e27a8532,
    name: "privacy-policy"
  }, {
    path: "/profilecompletion",
    component: _4c5ac025,
    name: "profilecompletion"
  }, {
    path: "/referral",
    component: _14562626,
    name: "referral"
  }, {
    path: "/settings",
    component: _ccad0b1a,
    name: "settings"
  }, {
    path: "/setup-profile",
    component: _74a36639,
    name: "setup-profile"
  }, {
    path: "/signup",
    component: _49829ae8,
    name: "signup"
  }, {
    path: "/terms-and-conditions",
    component: _7de36978,
    name: "terms-and-conditions"
  }, {
    path: "/test",
    component: _f43ee13c,
    name: "test"
  }, {
    path: "/company/dashboard",
    component: _50badee2,
    name: "company-dashboard"
  }, {
    path: "/company/getstarted",
    component: _0cf596e6,
    name: "company-getstarted"
  }, {
    path: "/company/onboarding",
    component: _5f672e3d,
    name: "company-onboarding"
  }, {
    path: "/company/positions",
    component: _8591fb8a,
    name: "company-positions"
  }, {
    path: "/company/profile",
    component: _1e2a123a,
    name: "company-profile"
  }, {
    path: "/company/signup",
    component: _0f04908c,
    name: "company-signup"
  }, {
    path: "/hyreadmin/demo",
    component: _11633cf7,
    name: "hyreadmin-demo"
  }, {
    path: "/hyreadmin/impersonate",
    component: _2cdb4315,
    name: "hyreadmin-impersonate"
  }, {
    path: "/hyreadmin/unimpersonate",
    component: _312f7e5c,
    name: "hyreadmin-unimpersonate"
  }, {
    path: "/myaccount/dashboard",
    component: _314d9c66,
    name: "myaccount-dashboard"
  }, {
    path: "/myaccount/profile",
    component: _c422a10a,
    name: "myaccount-profile"
  }, {
    path: "/myaccount/settings",
    component: _0d23a67e,
    name: "myaccount-settings"
  }, {
    path: "/company/profile/setup",
    component: _a9a75336,
    name: "company-profile-setup"
  }, {
    path: "/hyreadmin/portal/screening",
    component: _12d0ff2c,
    name: "hyreadmin-portal-screening"
  }, {
    path: "/hyreadmin/portal/talent",
    component: _43a992ce,
    name: "hyreadmin-portal-talent"
  }, {
    path: "/",
    component: _4f071832,
    name: "index"
  }, {
    path: "/hyreadmin/portal/screening/:screeningId",
    component: _628504ec,
    name: "hyreadmin-portal-screening-screeningId"
  }, {
    path: "/hyreadmin/portal/talent/:guid",
    component: _2ad87e64,
    name: "hyreadmin-portal-talent-guid"
  }, {
    path: "/company/positions/:slug",
    component: _87e1b594,
    name: "company-positions-slug"
  }, {
    path: "/company/positions/:slug/edit",
    component: _1cb87f56,
    name: "company-positions-slug-edit"
  }, {
    path: "/applicants/:id",
    component: _e166ffa8,
    name: "applicants-id"
  }, {
    path: "/hotlist-candidates/:candidateId?",
    component: _404bc39c,
    name: "hotlist-candidates-candidateId"
  }, {
    path: "/jobs/:id",
    component: _7800205e,
    name: "jobs-id"
  }, {
    path: "/plan/:plan?",
    component: _28144a72,
    name: "plan-plan"
  }, {
    path: "/refer/:code?",
    component: _4578645d,
    name: "refer-code"
  }, {
    path: "/talent/:id?",
    component: _65233f32,
    name: "talent-id"
  }, {
    path: "/hotlist-candidates/:positionSlug?/:candidateId",
    component: _24ab7418,
    name: "hotlist-candidates-positionSlug-candidateId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
